import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'


// Containers
const TheContainer = () => import('@/containers/TheContainer')
// const Maintenance = () => import('@/views/maintenance')

// Views
const AdminAuthLayout = () => import('@/views/AdminAuthLayout')
const Login = () => import('@/views/Login')
const Acs = () => import('@/views/Acs')
const Page403 = () => import('@/views/pages/page403')
const Register = () => import('@/views/Register')
const CreatePassword = () => import('@/views/CreatePassword')
const ForgotPassword = () => import('@/views/ForgotPassword')
const ResetPassword = () => import('@/views/ResetPassword')
const Dashboard = () => import('@/views/Dashboard')
const EditProfile = () => import('@/views/profile/EditProfile')
const ManageUser = () => import('@/views/profile/ManageUser')
const SectionAlias = () => import('@/views/profile/SectionAlias')
const ConsumptionReport = () => import('@/views/profile/ConsumptionReport')
const AddUser = () => import('@/views/profile/AddUser')
const ProjectListing = () => import('@/views/projects/ProjectListing')
const CreateProject = () => import('@/views/projects/CreateProject')
const ItemListing = () => import('@/views/Item Listing/ItemListing')
const AddItem = () => import('@/views/projects/AddItem')
const OfferListing = () => import('@/views/projects/OfferListing')
const AddOffer = () => import('@/views/projects/AddOffer')
const MRExtract = () => import('@/views/MR Extract/MRExtract')
const TBE = () => import('@/views/TBE/LHS/')
const TBERHS = () => import('@/views/TBE/RHS/')
const MRExtractPackage = () => import('@/views/MR Extract/MRExtractPackage')
const MRandOffer = () => import('@/views/Offer Evaluation/OfferEvaluation')
const OfferEvaluationPackage = () => import('@/views/Offer Evaluation/OfferEvaluationPackage')
const OfferComparison = () => import('@/views/projects/OfferComparison')
const DetailedComparison = () => import('@/views/Detail Offer Evaluation/DetailedComparison')
const TBEVendorComparison = () => import('@/views/TBE/vendorComparision')
const bulkVendorComparison = () => import('@/views/Bulk_Material/vendorCompare')
const DetailedPackageComparison = () => import('@/views/Detail Offer Evaluation/DetailComparePackage')
const RevisionComparison = () => import('@/views/Revision Comparison/RevisionComparison')
const TBERevisionComparison = () => import('@/views/TBE/revisionComparision')
const RevisionPackageComparison = () => import('@/views/Revision Comparison/RevisionComparePackage')
const TQListing = () => import('@/views/projects/TQListing')
const TQListingOld = () => import('@/views/projects/TQListingOld')
const PrcTQListing = () => import('@/views/PRC/PrcTQListing')
const PrcEnqListing = () => import('@/views/PRC/PrcEnqListing')
const ProjectUserListing = () => import('@/views/projects/ProjectUserListing')
const AddMember = () => import('@/views/projects/AddMember')
const RequisitionUserListing = () => import('@/views/Item Listing/RequisitionUserListing')
const MoreInsights = () => import('@/views/MoreInsights');
const profileLayout = () => import('@/views/profile/profileLayout')
const ManageLogo = () => import('@/components/manageLogo');
const IDCListing = () => import('@/views/IDC');

// Requisition Management
const CreateRequisition = () => import('@/views/Requisition Management/RequisitionCreate');
const RequisitionRFQCreate = () => import('@/views/Requisition Management/RequisitionRFQCreate');
const UploadRequisition = () => import('@/views/Requisition Management/UploadCreatedRequisition');
const RequisitionListing = () => import('@/views/Requisition Management/RequisitionListing');
const RequisitionPRCListing = () => import('@/views/Requisition Management/RequisitionPRCListing');
const RequisitionREListing = () => import('@/views/Requisition Management/RequisitionREListing');
const PreliminaryEvaluation = () => import('@/views/Requisition Management/PreliminaryEvaluation');
const RequisitionCollab = () => import('@/views/Requisition Management/RequisitionCollab')
const ViewOfferDetails = () => import('@/views/Requisition Management/ViewOfferDetails');


const bulkMaterialMR = () => import('@/views/Bulk_Material/bidtab/');
const bulkMaterialOffer = () => import('@/views/Bulk_Material/offer/');
const bulkMaterialVendor = () => import('@/views/Bulk_Material/vendor/');
const bidderListView = () => import('@/views/Requisition Management/BidderListView');
const bidderCollab = () => import('@/views/Requisition Management/BidderCollab');
const tsCollab = () => import('@/components/technicalSummary/collaboration.vue');
const roaCollab = () => import('@/components/ROA/collaboration.vue');


// Alt-View
const bidTabLHS= () => import('@/views/AlternateView/LHS/');
const bidTabRHS= () => import('@/views/AlternateView/RHS/');
const bidTabRevisionCompare= () => import('@/views/AlternateView/RevisionCompare/');
const bidTabVendorCompare= () => import('@/views/AlternateView/VendorCompare/');

// SearchReference
const SearchResults = () => import('@/views/Search/Results')
const ManageNotifications = () => import('@/views/profile/ManageNotification')
const DatasheetSearch = () => import('@/views/datasheet search/datasheetSearch.vue')
const CRSListing = () => import('@/views/CRS/CRSListing')
const CRSCreate = () => import('@/views/CRS/CRSCreate')
// please commect this when you push to dev and ahead
// do not remove this 
// const Test = () => import('@/views/test')
// Drawing routes
// const VersionListing = () => import('@/views/projects/VersionListing')
// const AddVersion = () => import('@/views/projects/AddVersion')
// const AddMarkup = () => import('@/views/projects/AddMarkup')

// Vendor view
const Vendor = () => import('@/views/Vendor/vendor')
const vendorContainer = () => import('@/views/Vendor/vendorContainer')
const VendorAuth = () => import('@/views/Vendor/VendorAuth')
const VendorEnqDetails = () => import('@/views/Vendor/VendorEnqDetails')
const VendorDetails = () => import('@/views/TBE/vendor')

// Manage TBE
const ManageTemplateAll = () => import('@/views/ManageTemplateAll');
const ManageTBEListing = () => import('@/views/ManageTBE/Listing');
const ManageTBETemplate = () => import('@/views/ManageTBE/Template');
const ManageCBEListing = () => import('@/views/ManageCBE/Listing');
const ManageCBETemplate = () => import('@/views/ManageCBE/Template');
const ManageRFQListing = () => import('@/views/RFQTemplate/RFQTemplateListing')
const ViewRFQTemplate = () => import('@/views/RFQTemplate/ViewRFQTemplate')
const ManageTMRFList = () => import('@/views/Requisition Management/ManageTMRList');

//TBE packages
const TBEPackagesLHS = () => import('@/views/TBE_Packages/LHS/')
const TBEPackagesRHS = () => import('@/views/TBE_Packages/RHS/')
const TBEPackagesRevisionComparison = () => import('@/views/TBE_Packages/revisionComparision')
const TBEPackagesVendorComparison = () => import('@/views/TBE_Packages/vendorComparision')
const TBEVendorEnqDetailsPackages = () => import('@/views/TBE_Packages/vendor')

// Manage TBE
const ManageVendorList = () => import('@/views/ManageVendorList');
const NdaCollab = () => import('@/views/ManageVendorList/NdaCollab');
// technical summary
const technicalSummary = () => import('@/views/Technical_Summary/index.vue');
const roa = () => import('@/views/ROA/index.vue');
const award = () => import('@/components/ROA/award.vue');

// Manage TBE
import store from '../store'
Vue.use(Router)


const router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/vendor',
      redirect: 'vendorAuth',
      component: Vendor,
      children: [
        {
          path: '',
          name: 'vendorAuth',
          component: VendorAuth
        },
      ]
    },
    {
      path: '/vendor',
      redirect: 'vendor',
      component: vendorContainer,
      children: [
        {
          path: 'VendorEnqDetails',
          name: 'VendorEnqDetails',
          component: VendorEnqDetails
        },
        {
          path: 'vendorenqdetails',
          name: 'VendorEnqDetails',
          component: VendorEnqDetails
        },
        {
          path: 'vendorDetails',
          name: 'VendorDetails',
          component: VendorDetails
        },
        {
          path: 'vendorDetailsPackages',
          name: 'View TBE (Vendor) Packages',
          component: TBEVendorEnqDetailsPackages,
        },
      ]
    },
    {
      path: '/',
      redirect: '/login',
      component: AdminAuthLayout,
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'acs',
          name: 'Acs',
          component: Acs
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        },
        {
          path: 'createpassword',
          name: 'Create Password',
          component: CreatePassword
        },
        {
          path: 'forgotpassword',
          name: 'Forgot Password',
          component: ForgotPassword
        },
        {
          path: 'resetpassword',
          name: 'Reset Password',
          component: ResetPassword
        },
      ]
    },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Dashboard',
      component: TheContainer,
      meta: {
        requiresAuth: true,
      },
      children: [
        // { // please commect this when you push to dev and ahead
        //   // do not remove this 
        //   path:'test',
        //   name: 'Test',
        //   component: Test
        // },
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '/page-403',
          name: 'Access Denied',
          component: Page403
        },
        {
          path: 'moreinsights',
          name: 'More Insights',
          component: MoreInsights
        },
        {
          path: 'results',
          name: 'Search Results',
          component: SearchResults
        },
        {
          path: 'managetemplateall',
          name: 'Templates',
          component: ManageTemplateAll,
        },
        {
          path: 'rfqtemplatelisting',
          name: 'TMR Template Listing',
          component: ManageRFQListing
        },
        {
          path: 'rfqtemplatelisting',
          name: 'RFQ Template Listing',
          component: ManageRFQListing
        },
        {
          path: 'viewrfqtemplate',
          name: 'Template View',
          component: ViewRFQTemplate
        },
        {
          path: 'managetemplate',
          name: 'TBE Template Listing',
          component: ManageTBEListing,
        },
        {
          path: 'managecbetemplate',
          name: 'CBE Template Listing',
          component: ManageCBEListing,
        },
        {
          path: 'template',
          name: 'Template',
          component: ManageTBETemplate,
        },
        {
          path: 'cbetemplate',
          name: 'CBE Template',
          component: ManageCBETemplate,
        },
        {
          path: 'managetmrlist',
          name: 'Manage TMR List',
          component: ManageTMRFList
        },
        {
          path: 'managevendorslist',
          name: 'Manage Vendor List',
          component: ManageVendorList
        },
        {
          path: 'ndacollab',
          name: 'NDA Collaboration',
          component: NdaCollab
        },
        // {
        //   path: 'managetemplate',
        //   redirect: '/managetemplate/listing',
        //   name: 'Manage Template',
        //   component: {
        //     render(c) { return c('router-view') }
        //   },
        //   children: [
           
            
        //   ]
        // },
        {
          path: 'profile',
          redirect: '/profile/editprofile',
          name: 'Profile',
          component: profileLayout,
          children: [
            {
              path: 'editprofile',
              name: 'Edit Profile',
              component: EditProfile,
            },
            {
              path: 'manageuser',
              name: 'Manage User',
              component: ManageUser,
            },
            {
              path: 'sectionalias',
              name: 'Manage Requisition Section Alias',
              component: SectionAlias
            },
            {
              path: 'reports',
              name: 'Usage Reports',
              component: ConsumptionReport,
            },
            {
              path: 'managelogo',
              name: 'Manage Logo',
              component: ManageLogo,
            },
            {
              path: 'notification',
              name: 'Manage Notifications',
              component: ManageNotifications,
            },
          ]
        },
        {
          path: '/adduser',
          name: 'Add user',
          component: AddUser
        },
        {
          path: '/datasheet-search',
          name: 'Manage Datasheet',
          component: DatasheetSearch
        },
        {
          path: 'projects',
          redirect: '/projects/listing',
          name: 'Projects',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'listing',
              name: 'Project Listing',
              component: ProjectListing,
            },
            {
              path: 'createproject',
              name: 'Create Project',
              component: CreateProject,
            },
            {
              path: 'itemlisting',
              name: 'Bid tab listing',
              component: ItemListing,
            },
            {
              path: 'additem',
              name: 'Add Item',
              component: AddItem,
            },
            {
              path: 'offerlisting',
              name: 'Offer Listing',
              component: OfferListing,
            },
            {
              path: 'addoffer',
              name: 'Add Offer',
              component: AddOffer,
            },
            {
              path: 'mrextract',
              name: 'View Bid tab (LHS) – Default',
              component: MRExtract,
            },
            {
              path: 'tbe',
              name: 'View Bid tab (LHS) – Default',
              component: TBE,
            },
            {
              path: 'mrextractpackage',
              name: 'View Bid tab (LHS) Packages',
              component: MRExtractPackage,
            },
            {
              path: 'mrandoffer',
              name: 'Offer Evaluation',
              component: MRandOffer,
            },
            {
              path: 'tberhs',
              name: 'View TBE (RHS) – Default',
              component: TBERHS,
            },
            {
              path: 'mrandofferpackage',
              name: 'Offer Evaluation Packages',
              component: OfferEvaluationPackage,
            },
            {
              path: 'offercomparison',
              name: 'Offer Comparison',
              component: OfferComparison,
            },
            {
              path: 'detailedcomparison',
              name: 'Detailed Comparison',
              component: DetailedComparison,
            },
            {
              path: 'detailedpackagecomparison',
              name: 'Detailed Comparison',
              component: DetailedPackageComparison,
            },
            {
              path: 'tbevendorcompare',
              name: 'View TBE (Vendor Comparison) – Default',
              component: TBEVendorComparison,
            },
            {
              path: 'bulkvendorcompare',
              name: 'View Offer (Vendor Comparison)',
              component: bulkVendorComparison,
            },
            {
              path: 'revisioncompare',
              name: 'Revision Comparison',
              component: RevisionComparison,
            },
            {
              path: 'revisionpackagecompare',
              name: 'Revision Comparison Package',
              component: RevisionPackageComparison,
            },
            {
              path: 'tberevisioncompare',
              name: 'View TBE (Revision Comparison) – Default',
              component: TBERevisionComparison,
            },
            {
              path: 'tqlisting',
              name: 'TQ Listing',
              component: TQListing,
            },
            {
              path: 'tqlistingold',
              name: 'TQ Listing Old',
              component: TQListingOld,
            },
            {
              path: 'prctqlisting',
              name: 'TQ Listing (Published)',
              component: PrcTQListing,
            },
            {
              path: 'prclisting',
              name: 'Procurement Enquiries Listing',
              component: PrcEnqListing
            },
            {
              path: 'members',
              name: 'Project Overview',
              component: ProjectUserListing,
            },
            {
              path: 'addmember',
              name: 'Add member',
              component: AddMember,
            },
            {
              path: 'requisitionuserlisting',
              name: 'Bid tab Overview',
              component: RequisitionUserListing,
            },
            {
              name: 'Collaboration',
              path: 'biddercollab',
              component: bidderCollab,
            },
            {
              path: 'idclisting',
              name: 'IDC Listing(LHS)',
              component: IDCListing,
            },
            {
              path: 'idclisting',
              name: 'IDC Listing(RHS)',
              component: IDCListing,
            },
            {
              path: 'idclistingreq',
              name: 'IDC Listing(Requisition Management)',
              component: IDCListing,
            },
            {
              path: 'createRequisition',
              name: 'Requisition Management (Create)',
              component: CreateRequisition
            },
            {
              path: 'uploadcreatedrequisition',
              name: 'Upload Created Requisition',
              component: UploadRequisition
            },
            {
              path: 'requisitionlisting',
              name: 'Requisition Listing',
              component: RequisitionListing,
            },
            {
              path: 'requisitionprclisting',
              name: 'Manage Requisition',
              component: RequisitionPRCListing,
            },
            {
              path: 'requisitionrelisting',
              name: 'Manage Technical Material Requisition (TMR) & Offer(s)',
              component: RequisitionREListing,
            },
            {
              path: 'preliminaryevaluation',
              name: 'Preliminary Evaluation',
              component: PreliminaryEvaluation,
            },
            {
              path: 'requisitioncollab',
              name: 'Requisition Collaboration',
              component: RequisitionCollab,
            },
            {
              path: 'bidderlistview',
              name: 'Vendor List View',
              component: bidderListView,
            },
            {
              path: 'bulkMR',
              name: 'BulkMR',
              component: bulkMaterialMR,
            },
            {
              path: 'bulkOffer',
              name: 'BulkOffer - Offer page',
              component: bulkMaterialOffer,
            },
            {
              path: 'bulkVendor',
              name: 'bulkVendor',
              component: bulkMaterialVendor,
            },
            {
              path: 'bidtablhs',
              name: 'View Bid tab (LHS) - Alternate View',
              component: bidTabLHS,
            },
            {
              path: 'bidtabrhs',
              name: 'Offer Evaluation - Alternate View',
              component: bidTabRHS,
            },
            {
              path: 'bidTabRevisionCompare',
              name: 'Revision Compare - Alternate View',
              component: bidTabRevisionCompare,
            },
            {
              path: 'bidtabvendorcompare',
              name: 'Vendor Compare - Alternate View',
              component: bidTabVendorCompare,
            },
            {
              path:'ts',
              name: 'Technical Summary',
              component: technicalSummary,
            },
            {
              path:'award',
              name: 'Award',
              component: award,
            },
            {
              path:'roa',
              name: 'ROA',
              component: roa,
            },
            {
              path:'tsCollab',
              name: 'Technical Summary Collaboration',
              component:tsCollab
            },
            {
              path:'roaCollab',
              name: 'ROA Collaboration',
              component:roaCollab
            },
            {
              path: '/crslisting',
              name: 'CRS Listing',
              component: CRSListing
            },
            {
              path: '/upload-crs',
              name: ' Upload Commented PDF',
              component: CRSCreate
            },
            {
              path: '/requisitionrfqcreate',
              name: 'Edit / View Requisition',
              component: RequisitionRFQCreate
            },
            {
              path: 'packageslhs',
              // NOTE: must stay distinct from 'View Bid tab (LHS) Packages' at the mrextractpackage
              // route above — vue-router 3 silently keeps the first registration of a duplicate name.
              name: 'View Bidtab (LHS) Packages',
              component: TBEPackagesLHS,
            },
            {
              path: 'packagesrhs',
              name: 'View TBE (RHS) Packages',
              component: TBEPackagesRHS,
            },
            {
              path: 'packagesrevisioncompare',
              name: 'View TBE (Revision Comparison) Packages',
              component: TBEPackagesRevisionComparison,
            },
            {
              path: 'packagesvendorcompare',
              name: 'View TBE (Vendor Comparison) Packages',
              component: TBEPackagesVendorComparison,
            },
            {
              path: 'viewofferdetails',
              name: 'View Offer Details',
              component: ViewOfferDetails,
            }
          ]
        },
      ]
    },
  ]
})

axios.interceptors.response.use(
  function(response) {
    // Any status code that lies within the range of 2xx causes this function to trigger
    return response;
  }, 
  function(error) {
    // Any status codes that fall outside the range of 2xx cause this function to trigger
    if (error.response && error.response?.status === 403) {
      // Redirect to the specified route
      // prompt('You do not have access to this page!')
      router.push('/page-403');  // Adjust this route as necessary
    }
    return Promise.reject(error);
  }
);
router.beforeEach((to, from, next) => {
  console.log('before route => ', to , from, next);
  // Adopt/clear a cross-product session before the auth check (no-op off a
  // shared domain). navigate:false -> never reloads/redirects from here; it only
  // updates localStorage['user'], and the loggedIn check below handles the redirect.
  store.dispatch('auth/reconcileFromShared', { navigate: false })
  let loggedIn = JSON.parse(localStorage.getItem('user'))
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !loggedIn) {
    // console.log('login req => ', requiresAuth, loggedIn);
    // sessionStorage.setItem('pathToLoadAfterLogin', window.location.pathname + window.location.search)
    let loginPath = window.location.pathname + window.location.search
    localStorage.setItem('pervloginPath', loginPath)
    // next({ path: '/login'})
    next({ name: 'Login', query: { from: loginPath } });
  }else if (!requiresAuth && loggedIn) {
    next('dashboard')
  } else {
    next();
  }
})

export default router
